import styled from 'styled-components';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import { colorTheme } from '@styles/muiTheme';
import { TextInput } from '@shared/inputs/TextInput';

export const Body = styled.div`
  display: flex;
  font-size: 14px;
  max-height: 700px;
`;

export const Titles = styled.div`
  width: 245px;
  min-width: 245px;
`;

export const Header = styled.div`
  display: flex;
  padding-top:10px;
  align-items: center;
  position: sticky;
  z-index: 999;
  top: 0;
  background: ${colorTheme.palette.common.white};
`;

export const RemoveButton = styled(IconButton)`
  width: 15px;
  height: 15px;
  background: ${colorTheme.palette.secondary.main};
  color: ${colorTheme.palette.common.white};
`;

export const LenderHeader = styled.div`
  height: 64px;
  min-width: 220px;
  max-width: 220px;
  padding: 0 5px 0 30px;
  color: ${colorTheme.palette.primary.light};
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;

export const Title = styled.div<{ onClick?(): void }>`
  height: 40px;
  width: 220px;
  display: flex;
  align-items: center;
  font-weight: 600;

  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
    
    &:hover {
     opacity: .8;
    }
  `};
`;

export const RelativeFlexWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 1px;
  flex: 1;
`;

export const LenderNames = styled.div`
  display: flex;
  align-items: center;
`;

export const LendersList = styled.div`
  display: flex;
  flex: 1;
`;

export const ExcludedLenders = styled.div`
  display: flex;
  border-left: 1px solid ${colorTheme.palette.grey[500]};
  width: 100%;
  min-width: 310px;
  max-width: 310px;
  flex-direction: column;
`;

export const ExcludedLendersContainer = styled.div`
  max-height: 548px;
  overflow: auto;
  padding-right: 10px;
  margin-right: -24px;
`;

export const IconWrapper = styled.div`
  margin: 0 5px 0 -4px;
  display: flex;
  color: ${colorTheme.palette.primary.light};
`;

export const TitlesFooter = styled.div`
  padding: 0 12px;
  background: ${colorTheme.palette.secondary.light};
  border-radius: 8px 0 0 8px;
`;

export const ILendingLoaderWrapper = styled(Box)`
  margin-bottom: 16px;
  padding: 0 16px;
  overflow: auto;
  height: 500px;
`;

export const LenderCommentInput = styled(TextInput)`
  margin-bottom: 16px;
  padding: 0 16px;
  color: ${colorTheme.palette.primary.main}; 
`;

export const LenderContainer = styled(Box)`
  display: inline-grid;
  max-height: 600px;
  width: 100%;
  position: relative;
  overflow: auto;
  z-index: 2;
`;